import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { login as loginApi } from '../services/api';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await loginApi(username, password);
      login(data.token, data.admin);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black p-4">
      <div className="bg-white p-8 rounded-lg w-full max-w-sm text-center shadow-xl">
        <div className="flex items-center justify-center gap-2 mb-6">
          <span className="text-4xl font-black tracking-widest">BROLAX</span>
          <span className="bg-brolax-red text-white px-2 py-1 rounded font-black">BX</span>
        </div>
        <h2 className="text-xl font-bold mb-4">تسجيل دخول المشرف</h2>

        {error && <div className="bg-red-100 text-brolax-red p-2 rounded mb-4 text-sm">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="text-right mb-4">
            <label className="block mb-1 font-semibold">اسم المستخدم</label>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required autoFocus
              className="w-full p-3 border-2 border-gray-300 rounded font-cairo text-lg" />
          </div>

          <div className="text-right mb-4">
            <label className="block mb-1 font-semibold">كلمة المرور</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full p-3 border-2 border-gray-300 rounded font-cairo text-lg" />
          </div>

          <button type="submit" disabled={loading}
            className="w-full bg-brolax-red text-white py-3 rounded font-bold text-lg hover:bg-brolax-red-dark disabled:bg-gray-400 transition">
            {loading ? 'جاري الدخول...' : 'دخول'}
          </button>
        </form>
      </div>
    </div>
  );
}